(function () {
  'use strict';

  const popupHTML = `
<div id="vd-overlay" style="display:none;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.55);z-index:999999;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;">
  <div id="vd-modal" style="background:#fff;border-radius:20px;width:760px;max-width:calc(100vw - 32px);max-height:90vh;overflow-y:auto;position:relative;font-family:'Hanken Grotesk','Segoe UI',sans-serif;box-shadow:0 20px 60px rgba(0,0,0,0.25);">

    <button id="vd-close" style="position:absolute;top:14px;right:16px;background:none;border:none;font-size:22px;cursor:pointer;color:#555;z-index:10;line-height:1;">&#x2715;</button>

    <div id="vd-top-grid" style="display:grid;grid-template-columns:320px 1fr;min-height:360px;">

      <div style="background:#f5f0ea;border-radius:20px 0 0 0;padding:24px 20px 20px;display:flex;flex-direction:column;align-items:center;gap:14px;box-sizing:border-box;overflow:hidden;">
        <div style="width:100%;display:flex;align-items:center;justify-content:center;height:220px;flex-shrink:0;">
          <img id="vd-main-img" src="" alt="" style="max-width:100%;max-height:220px;object-fit:contain;border-radius:10px;">
        </div>
        <div id="vd-thumb-slider-wrap" style="width:100%;align-items:center;gap:6px;display:none;">
          <button id="vd-thumb-prev" style="flex-shrink:0;width:28px;height:28px;border-radius:50%;border:1.5px solid #ccc;background:#fff;cursor:pointer;font-size:18px;line-height:1;color:#555;display:flex;align-items:center;justify-content:center;padding:0;transition:all 0.15s;">&#8249;</button>
          <div id="vd-thumb-gallery" style="display:flex;flex-direction:row;gap:8px;align-items:center;overflow:hidden;flex:1;padding:2px 0;"></div>
          <button id="vd-thumb-next" style="flex-shrink:0;width:28px;height:28px;border-radius:50%;border:1.5px solid #ccc;background:#fff;cursor:pointer;font-size:18px;line-height:1;color:#555;display:flex;align-items:center;justify-content:center;padding:0;transition:all 0.15s;">&#8250;</button>
        </div>
      </div>

      <div style="padding:28px 24px 24px;display:flex;flex-direction:column;box-sizing:border-box;overflow-y:auto;">
        <div id="vd-title" style="font-size:22px;font-weight:700;color:#1a1a1a;margin-bottom:6px;font-family:'Fraunces',Georgia,serif;line-height:1.3;">Loading...</div>
        <div id="vd-stars" style="color:#f4a024;font-size:13px;letter-spacing:1px;margin-bottom:4px;display:none;">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
        <div id="vd-price" style="font-size:22px;font-weight:800;color:#ff6a00;margin-bottom:10px;">$0.00</div>
        <div id="vd-desc" style="font-size:12px;color:#666;line-height:1.6;margin-bottom:12px;"></div>
        <div id="vd-options-container"></div>
        <div style="display:flex;align-items:center;gap:10px;margin-bottom:14px;">
          <button id="vd-minus" style="width:32px;height:32px;border-radius:8px;border:1px solid #ddd;background:#fff;font-size:18px;cursor:pointer;color:#333;display:flex;align-items:center;justify-content:center;">-</button>
          <span id="vd-qty" style="font-size:15px;font-weight:600;min-width:20px;text-align:center;color:#1a1a1a;">1</span>
          <button id="vd-plus" style="width:32px;height:32px;border-radius:8px;border:1px solid #ddd;background:#fff;font-size:18px;cursor:pointer;color:#333;display:flex;align-items:center;justify-content:center;">+</button>
        </div>
        <button id="vd-add-btn" style="width:100%;padding:13px;background:#ff6a00;color:#fff;border:none;border-radius:10px;font-size:14px;font-weight:700;cursor:pointer;transition:background 0.15s;">+ ADD TO BUNDLE</button>
        <div style="font-size:11px;color:#aaa;text-align:center;margin-top:6px;">Bundle savings apply automatically.</div>
      </div>
    </div>

    <div style="padding:18px 28px;border-top:1px solid #f0ebe3;">
      <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;display:none;" id="vd-pet-section">
        <span style="color:#ff6a00;">&#128062;</span>
        <span id="vd-pet-label" style="font-size:13px;font-weight:700;color:#1a1a1a;"></span>
      </div>
      <div id="vd-features" style="display:grid;grid-template-columns:1fr 1fr;gap:8px;display:none;" id="vd-features-section"></div>
    </div>

    <div id="vd-accordions" style="padding:0 28px 20px;"></div>

  </div>
</div>`;

  document.body.insertAdjacentHTML('beforeend', popupHTML);

  const style = document.createElement('style');
  style.textContent = `
    #vd-overlay.open { display: flex !important; }
    #vd-thumb-slider-wrap { display: none; }
    #vd-thumb-slider-wrap.visible { display: flex !important; }
    #vd-add-btn:hover { background: #e05a00 !important; }
    .vd-option-group { margin-bottom: 14px; }
    .vd-option-label { font-size: 12px; color: #888; margin-bottom: 6px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; }
    .vd-option-values { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }
div:empty{display: block;}
    .vd-btn {
      padding: 8px 14px; border-radius: 6px; border: 1.5px solid #ddd;
      font-size: 12px; cursor: pointer; background: #fff; color: #333;
      transition: all 0.15s; font-family: 'Hanken Grotesk','Segoe UI',sans-serif; font-weight: 500;
    }
    .vd-btn:hover:not(.unavailable) { border-color: #ff6a00; color: #ff6a00; }
    .vd-btn.active { background: #ff6a00; color: #fff; border-color: #ff6a00; }
    .vd-btn.unavailable { opacity: 0.35; cursor: not-allowed; text-decoration: line-through; }

    .vd-color-dot {
      width: 32px; height: 32px; border-radius: 50%; cursor: pointer;
      border: 2px solid transparent; transition: all 0.15s;
      box-shadow: 0 1px 3px rgba(0,0,0,0.15);
      position: relative;
    }
    .vd-color-dot:hover:not(.unavailable) { transform: scale(1.12); }
    .vd-color-dot.active { border-color: #ff6a00; outline: 2px solid #ff6a00; outline-offset: 2px; }
    .vd-color-dot.unavailable { opacity: 0.3; cursor: not-allowed; }
    .vd-color-dot.unavailable::after {
      content: ''; position: absolute; inset: 0;
      background: repeating-linear-gradient(45deg, transparent, transparent 4px, rgba(0,0,0,0.3) 4px, rgba(0,0,0,0.3) 5px);
      border-radius: 50%;
    }

    .vd-feature-item { display: flex; align-items: flex-start; gap: 6px; font-size: 12px; color: #555; line-height: 1.4; }

    .vd-acc-btn {
      width: 100%; display: flex; justify-content: space-between; align-items: center;
      background: none; border: none; padding: 12px 0; font-size: 13px; font-weight: 600;
      color: #1a1a1a; cursor: pointer; border-top: 1px solid #f0ebe3;
      font-family: 'Hanken Grotesk','Segoe UI',sans-serif;
    }
    .vd-acc-content {
      font-size: 13px; color: #666; line-height: 1.6; padding: 0 0 10px; display: none;
    }
    .vd-acc-content.open { display: block !important; }

    /* Details tab content styles inside popup */
    .vd-acc-content h2, .vd-acc-content h3, .vd-acc-content h4 { font-weight: 600; color: #1a1a1a; margin-bottom: 6px; }
    .vd-acc-content p { margin-bottom: 8px; }
    .vd-acc-content ul, .vd-acc-content ol { padding-left: 18px; margin-bottom: 8px; }
    .vd-acc-content ul li { list-style: disc; margin-bottom: 4px; }
    .vd-acc-content ol li { list-style: decimal; margin-bottom: 4px; }
    .vd-acc-content a { color: #ff6a00; text-decoration: underline; }
    .vd-acc-content table { width: 100%; border-collapse: collapse; margin-bottom: 8px; }
    .vd-acc-content td, .vd-acc-content th { border: 1px solid #e0e0e0; padding: 6px 10px; font-size: 12px; }
    .vd-acc-content img { max-width: 100%; border-radius: 6px; }

    .view-detail-btn {
      background: transparent; color: #555; border: 1.5px solid #bbb;
      padding: 5px 14px; border-radius: 30px; font-size: 12px; font-weight: 500;
      cursor: pointer; width: auto; margin: 4px auto 6px;
      display: flex; align-items: center; justify-content: center; gap: 5px;
      transition: all 0.15s; font-family: 'Hanken Grotesk','Segoe UI',sans-serif;
    }
    .view-detail-btn:hover { border-color: #ff6a00; color: #ff6a00; }
    .view-detail-btn .vd-info-icon {
      width: 15px; height: 15px; border-radius: 50%; border: 1.5px solid currentColor;
      display: inline-flex; align-items: center; justify-content: center;
      font-size: 10px; font-weight: 700;
    }

    #vd-thumb-gallery::-webkit-scrollbar { display: none; }
    #vd-thumb-prev:hover, #vd-thumb-next:hover { border-color: #ff6a00 !important; color: #ff6a00 !important; }

    .vd-thumb-img {
      width: 50px; height: 50px; border-radius: 6px; cursor: pointer;
      border: 2px solid #ddd; object-fit: cover; transition: all 0.2s;
      background: #fff;
    }
    .vd-thumb-img:hover { transform: scale(1.08); border-color: #ff6a00; }
    .vd-thumb-img.active { border-color: #ff6a00; box-shadow: 0 0 8px rgba(255, 106, 0, 0.4); }

    @media (max-width: 620px) {
      #vd-top-grid { grid-template-columns: 1fr !important; }
      #vd-modal { border-radius: 16px !important; width: calc(100vw - 32px) !important; }
      #vd-features { grid-template-columns: 1fr !important; }
      .vd-thumb-img { width: 56px; height: 56px; }
    }
  `;
  document.head.appendChild(style);

  const COLOR_MAP = {
    navy:'#1b3a6b', blue:'#2a5fa8', purple:'#6b2f8a', violet:'#7c3aed',
    pink:'#f5a8c0', rose:'#e11d48', red:'#dc2626', orange:'#ea580c',
    green:'#16a34a', teal:'#0d9488', mint:'#6ee7b7', sage:'#84cc16',
    yellow:'#eab308', gold:'#d97706', amber:'#f59e0b',
    white:'#ffffff', black:'#111827', grey:'#6b7280', gray:'#6b7280',
    brown:'#78350f', tan:'#d97706', cream:'#fef3c7',
    coral:'#f97316', magenta:'#d946ef', lilac:'#c4b5fd',
  };

  function colorToCSS(name) {
    if (!name) return '#cccccc';
    const lower = String(name).toLowerCase().trim();
    for (const [key, val] of Object.entries(COLOR_MAP)) {
      if (lower.includes(key)) return val;
    }
    return '#cccccc';
  }

  let currentProduct  = null;
  let currentQty      = 1;
  let activeAddBtn    = null;
  let activeCard      = null;
  let selectedOptions = {};
  let productImages   = [];
  let currentImageIdx = 0;

  function findMatchingVariant() {
    if (!currentProduct?.variants) return null;
    const checks = Object.entries(selectedOptions);
    let variant = currentProduct.variants.find(v =>
      checks.every(([idx, val]) => v['option' + idx] === val) && v.available
    );
    return variant
      || currentProduct.variants.find(v => v.available)
      || currentProduct.variants[0];
  }

  function updatePrice() {
    const v = findMatchingVariant();
    if (v?.price != null) {
      document.getElementById('vd-price').textContent =
        '$' + (v.price / 100).toFixed(2);
    }
  }

  function rebuildThumbnailGallery() {
    const gallery = document.getElementById('vd-thumb-gallery');
    const sliderWrap = document.getElementById('vd-thumb-slider-wrap');
    const prevBtn = document.getElementById('vd-thumb-prev');
    const nextBtn = document.getElementById('vd-thumb-next');

    gallery.innerHTML = '';

    if (productImages.length <= 1) {
      sliderWrap.classList.remove('visible');
      return;
    }

    sliderWrap.classList.add('visible');

    productImages.forEach((imgUrl, i) => {
      const thumb = document.createElement('img');
      thumb.className = 'vd-thumb-img' + (i === currentImageIdx ? ' active' : '');
      thumb.src = imgUrl;
      thumb.alt = 'Product image ' + (i + 1);
      thumb.style.flexShrink = '0';

      thumb.addEventListener('click', function(e) {
        e.stopPropagation();
        setCurrentImage(i);
      });

      gallery.appendChild(thumb);
    });

    prevBtn.onclick = () => {
      const newIdx = Math.max(0, currentImageIdx - 1);
      setCurrentImage(newIdx);
    };
    nextBtn.onclick = () => {
      const newIdx = Math.min(productImages.length - 1, currentImageIdx + 1);
      setCurrentImage(newIdx);
    };

    updateSliderArrows();
  }

  function updateSliderArrows() {
    const prevBtn = document.getElementById('vd-thumb-prev');
    const nextBtn = document.getElementById('vd-thumb-next');
    if (!prevBtn || !nextBtn) return;
    prevBtn.style.opacity = currentImageIdx <= 0 ? '0.3' : '1';
    prevBtn.style.cursor  = currentImageIdx <= 0 ? 'default' : 'pointer';
    nextBtn.style.opacity = currentImageIdx >= productImages.length - 1 ? '0.3' : '1';
    nextBtn.style.cursor  = currentImageIdx >= productImages.length - 1 ? 'default' : 'pointer';
  }

  function setCurrentImage(idx) {
    if (idx < 0 || idx >= productImages.length) return;

    currentImageIdx = idx;

    const mainImg = document.getElementById('vd-main-img');
    if (mainImg) mainImg.src = productImages[idx];

    document.querySelectorAll('.vd-thumb-img').forEach((thumb, i) => {
      thumb.classList.toggle('active', i === idx);
    });

    const gallery = document.getElementById('vd-thumb-gallery');
    const activeThumb = gallery?.children[idx];
    if (activeThumb && gallery) {
      const thumbLeft = activeThumb.offsetLeft;
      const thumbW    = activeThumb.offsetWidth;
      const galW      = gallery.clientWidth;
      gallery.scrollTo({ left: thumbLeft - (galW / 2) + (thumbW / 2), behavior: 'smooth' });
    }

    updateSliderArrows();
  }

  function updateImage() {
    const v = findMatchingVariant();

    productImages = [];

    if (v?.featured_image?.src) {
      productImages.push(v.featured_image.src);
    }

    if (v?.image?.src && !productImages.includes(v.image.src)) {
      productImages.push(v.image.src);
    }

    if (currentProduct?.images && Array.isArray(currentProduct.images)) {
      currentProduct.images.forEach(img => {
        const src = img.src || img;
        if (src && typeof src === 'string' && !productImages.includes(src)) {
          productImages.push(src);
        }
      });
    }

    if (v?.images && Array.isArray(v.images)) {
      v.images.forEach(img => {
        const src = img.src || img;
        if (src && typeof src === 'string' && !productImages.includes(src)) {
          productImages.push(src);
        }
      });
    }

    if (activeCard) {
      activeCard.querySelectorAll('.popup-img').forEach(img => {
        const variantIds = img.dataset.variants;
        if (!variantIds || (v && variantIds.includes(String(v.id)))) {
          if (img.src && !productImages.includes(img.src)) {
            productImages.push(img.src);
          }
        }
      });
    }

    if (productImages.length === 0) {
      const fallback = currentProduct?.featured_image;
      if (fallback) {
        const src = typeof fallback === 'string' ? fallback : fallback.src;
        if (src) productImages.push(src);
      }
    }

    currentImageIdx = 0;
    rebuildThumbnailGallery();
    setCurrentImage(0);
  }

  function updateAvailability() {
    if (!currentProduct?.variants) return;
    const checks = Object.entries(selectedOptions);

    document.querySelectorAll('#vd-options-container [data-opt-idx]').forEach(el => {
      const elIdx = el.dataset.optIdx;
      const elVal = el.dataset.value;

      const ok = currentProduct.variants.some(v => {
        if (v['option' + elIdx] !== elVal) return false;
        return checks.every(([idx, val]) => {
          if (idx === elIdx) return true;
          return v['option' + idx] === val;
        }) && v.available;
      });

      el.classList.toggle('unavailable', !ok);
    });
  }

  // ============================================================
  // DETAILS TABS ACCORDIONS BUILD - IMPROVED WITH FALLBACK
  // ============================================================
  function buildAccordions(productData) {
    const accordionsContainer = document.getElementById('vd-accordions');
    
    if (!accordionsContainer) return;

    const detailsTabs = productData.details_tabs;
    let sectionsToRender = [];

    // Check if details tabs exist and are valid
    if (detailsTabs && Array.isArray(detailsTabs) && detailsTabs.length > 0) {
      // Filter out empty sections
      sectionsToRender = detailsTabs.filter(s => s && (s.title || s.content));
    }

    // If no details tabs, use fallback
    if (sectionsToRender.length === 0) {
      sectionsToRender = [
        { title: 'Product Details', content: 'Premium quality product designed for your needs. Made from food-safe materials.' },
        { title: 'Size Guide', content: 'Available in multiple sizes. Choose based on your requirements.' },
        { title: 'Cleaning & Care', content: 'Easy to clean and maintain. Machine washable. Handle with care.' },
        { title: 'Shipping & Returns', content: 'Free shipping on orders over $35. Returns accepted within 30 days of delivery.' },
      ];
    }

    // Render accordions
    accordionsContainer.innerHTML = sectionsToRender
      .map((section, i) => `
        <button class="vd-acc-btn" data-i="${i}" type="button">
          <span>${section.title || 'Details'}</span>
          <span id="vd-acc-icon-${i}" style="font-size:18px;color:#ff6a00;">+</span>
        </button>
        <div class="vd-acc-content" id="vd-acc-${i}">
          ${section.content || ''}
        </div>
      `)
      .join('');

    // Add click handlers
    document.querySelectorAll('.vd-acc-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const i = this.dataset.i;
        const content = document.getElementById('vd-acc-' + i);
        const icon    = document.getElementById('vd-acc-icon-' + i);
        const isOpen  = content.classList.contains('open');
        
        // Close all others
        document.querySelectorAll('.vd-acc-content').forEach(c => {
          c.classList.remove('open');
          c.style.display = 'none';
        });
        document.querySelectorAll('.vd-acc-icon').forEach(ic => {
          ic.textContent = '+';
        });
        
        // Toggle current
        if (!isOpen) {
          content.classList.add('open');
          content.style.display = 'block';
          icon.textContent = '−';
        }
      });
    });
  }

  // ============================================================
  // PET LABEL
  // ============================================================
  function getPetLabel(productData) {
    const tags = productData.tags || [];
    const tagsArr = Array.isArray(tags)
      ? tags
      : String(tags).split(',').map(t => t.trim());

    const isCat = tagsArr.some(t => t.toLowerCase() === 'freezpaw');
    return isCat ? 'Why cat parents love it' : 'Why dog parents love it';
  }

  function openPopup(productData, addBtnEl, cardEl) {
    if (!productData) {
      console.error('❌ No product data');
      alert('Error loading product');
      return;
    }

    currentProduct  = productData;
    currentQty      = 1;
    activeAddBtn    = addBtnEl;
    activeCard      = cardEl;
    selectedOptions = {};
    productImages   = [];
    currentImageIdx = 0;

    const titleEl = document.getElementById('vd-title');
    const cardTitle = cardEl
      ? (cardEl.querySelector('h4, h3, h2, .product-title, .card-title, .recipe-card__title')?.textContent?.trim())
      : null;
    const productTitle = productData.title || productData.name || productData.product_name || cardTitle || 'Product';
    titleEl.textContent = productTitle;

    document.getElementById('vd-qty').textContent = '1';

    const firstVariant = productData.variants?.find(v => v.available) || productData.variants?.[0];
    if (firstVariant) {
      const price = (firstVariant.price || 0) / 100;
      document.getElementById('vd-price').textContent = '$' + price.toFixed(2);
    }

    const cleanDesc = (productData.description || '').replace(/<[^>]+>/g, '');
    document.getElementById('vd-desc').textContent =
      (cleanDesc.substring(0, 160) + (cleanDesc.length > 160 ? '…' : '')) || 'Premium product';

    // Pet label
    const petSection = document.getElementById('vd-pet-section');
    const petLabel = document.getElementById('vd-pet-label');
    petLabel.textContent = getPetLabel(productData);
    petSection.style.display = 'flex';

    const optionsContainer = document.getElementById('vd-options-container');
    optionsContainer.innerHTML = '';

    if (cardEl) {
      buildOptionsFromCard(cardEl, productData, optionsContainer);
    } else {
      buildOptionsFromProductData(productData, optionsContainer);
    }

    updateAvailability();
    updateImage();

    // Features
    const featuresList = [
      'Premium quality and durability',
      'Versatile and multi-functional',
      'Easy to use and maintain',
      'Great value for money',
      'Customer approved',
      'Expert recommended',
    ];
    const featuresSection = document.getElementById('vd-features');
    featuresSection.innerHTML = featuresList
      .map(f => `<div class="vd-feature-item"><span style="color:#2da66e;font-size:13px;flex-shrink:0;">✓</span><span>${f}</span></div>`)
      .join('');
    featuresSection.style.display = 'grid';

    // Accordions - IMPORTANT!
    buildAccordions(productData);

    document.getElementById('vd-add-btn').onclick = () => {
      const variant = findMatchingVariant();
      if (!variant || !activeAddBtn) { 
        alert('Please select options'); 
        return; 
      }

      const card = activeAddBtn.closest('.product-card');
      const qtyInput = card?.querySelector('input[type="number"]');
      if (qtyInput) qtyInput.value = currentQty;

      activeAddBtn.dataset.id    = variant.id;
      activeAddBtn.dataset.price = variant.price;
      activeAddBtn.click();
      closePopup();
    };

    document.getElementById('vd-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function buildOptionsFromCard(cardEl, productData, container) {
    const colorSwatches = cardEl.querySelectorAll(
      '.color-swatch, [data-option-index][style*="background-color"], .swatch[data-color]'
    );
    const sizeSwatches = cardEl.querySelectorAll(
      '.size-swatch, .size-option, .size-btn, [data-size]'
    );

    const allSwatches = [...colorSwatches, ...sizeSwatches];
    const optionIndexMap = {};

    allSwatches.forEach(sw => {
      const idx   = sw.dataset.optionIndex;
      const val   = sw.dataset.value;

      if (!idx && sw.dataset.color) {
        sw.dataset.optionIndex = '1';
        sw.dataset.value = sw.dataset.color;
      }
      if (!idx && sw.dataset.size) {
        sw.dataset.optionIndex = '2';
        sw.dataset.value = sw.dataset.size;
      }

      const idx_final   = sw.dataset.optionIndex;
      const val_final   = sw.dataset.value;
      const isCol = sw.classList.contains('color-swatch') || /background-color|color/i.test(sw.getAttribute('style') || '');

      if (!idx_final || !val_final) return;

      if (!optionIndexMap[idx_final]) {
        const optObj = productData.options?.find(o => String(o.position) === String(idx_final));
        optionIndexMap[idx_final] = {
          name:    optObj?.name || (isCol ? 'Color' : 'Size'),
          isColor: isCol,
          values:  [],
        };
      }

      if (!optionIndexMap[idx_final].values.find(v => v.value === val_final)) {
        optionIndexMap[idx_final].values.push({
          value:    val_final,
          isActive: sw.classList.contains('active'),
        });
      }
    });

    const sortedIdxs = Object.keys(optionIndexMap).sort();

    if (!sortedIdxs.length) {
      buildOptionsFromProductData(productData, container);
      return;
    }

    const variants = productData.variants || [];
    if (
      variants.length === 1 &&
      (variants[0].title === 'Default Title' || variants[0].option1 === 'Default Title')
    ) return;

    sortedIdxs.forEach(idx => {
      const { name, isColor, values } = optionIndexMap[idx];

      const activeVal = values.find(v => v.isActive)?.value || values[0]?.value;
      if (activeVal) selectedOptions[idx] = activeVal;

      const group = document.createElement('div');
      group.className = 'vd-option-group';

      const label = document.createElement('div');
      label.className = 'vd-option-label';
      label.textContent = name;
      group.appendChild(label);

      const valuesDiv = document.createElement('div');
      valuesDiv.className = 'vd-option-values';

      values.forEach(({ value }) => {
        const isActive = value === activeVal;

        if (isColor) {
          const swatch = document.createElement('div');
          swatch.className   = 'vd-color-dot' + (isActive ? ' active' : '');
          swatch.style.backgroundColor = colorToCSS(value);
          swatch.title       = value;
          swatch.dataset.value   = value;
          swatch.dataset.optIdx  = idx;

          swatch.onclick = () => {
            if (swatch.classList.contains('unavailable')) return;
            valuesDiv.querySelectorAll('.vd-color-dot').forEach(s => s.classList.remove('active'));
            swatch.classList.add('active');
            selectedOptions[idx] = value;
            updatePrice(); updateImage(); updateAvailability();
          };
          valuesDiv.appendChild(swatch);

        } else {
          const btn = document.createElement('button');
          btn.className        = 'vd-btn' + (isActive ? ' active' : '');
          btn.textContent      = value;
          btn.dataset.value    = value;
          btn.dataset.optIdx   = idx;
          btn.type = 'button';

          btn.onclick = (e) => {
            e.preventDefault();
            if (btn.classList.contains('unavailable')) return;
            valuesDiv.querySelectorAll('.vd-btn').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            selectedOptions[idx] = value;
            updatePrice(); updateImage(); updateAvailability();
          };
          valuesDiv.appendChild(btn);
        }
      });

      group.appendChild(valuesDiv);
      container.appendChild(group);
    });
  }

  function buildOptionsFromProductData(productData, container) {
    const options = productData.options || [];
    if (!options.length) return;

    const variants = productData.variants || [];
    if (
      variants.length === 1 &&
      (variants[0].title === 'Default Title' || variants[0].option1 === 'Default Title')
    ) return;

    const normalized = options.map((opt, i) => {
      if (typeof opt === 'string') {
        const key  = 'option' + (i + 1);
        const seen = new Set();
        const vals = [];
        (productData.variants || []).forEach(v => {
          if (v[key] && !seen.has(v[key])) { seen.add(v[key]); vals.push(v[key]); }
        });
        return { name: opt, position: i + 1, values: vals };
      }
      return opt;
    });

    normalized.forEach(opt => {
      const idx    = String(opt.position);
      const values = (opt.values || []).filter(v => v !== 'Default Title');
      if (!values.length) return;

      selectedOptions[idx] = values[0];

      const isColor = /colou?r/i.test(opt.name);

      const group = document.createElement('div');
      group.className = 'vd-option-group';

      const label = document.createElement('div');
      label.className = 'vd-option-label';
      label.textContent = opt.name;
      group.appendChild(label);

      const valuesDiv = document.createElement('div');
      valuesDiv.className = 'vd-option-values';

      values.forEach((value, vi) => {
        const isActive = vi === 0;

        if (isColor) {
          const swatch = document.createElement('div');
          swatch.className  = 'vd-color-dot' + (isActive ? ' active' : '');
          swatch.style.backgroundColor = colorToCSS(value);
          swatch.title      = value;
          swatch.dataset.value   = value;
          swatch.dataset.optIdx  = idx;

          swatch.onclick = () => {
            if (swatch.classList.contains('unavailable')) return;
            valuesDiv.querySelectorAll('.vd-color-dot').forEach(s => s.classList.remove('active'));
            swatch.classList.add('active');
            selectedOptions[idx] = value;
            updatePrice(); updateImage(); updateAvailability();
          };
          valuesDiv.appendChild(swatch);
        } else {
          const btn = document.createElement('button');
          btn.className     = 'vd-btn' + (isActive ? ' active' : '');
          btn.textContent   = value;
          btn.dataset.value  = value;
          btn.dataset.optIdx = idx;
          btn.type = 'button';

          btn.onclick = (e) => {
            e.preventDefault();
            if (btn.classList.contains('unavailable')) return;
            valuesDiv.querySelectorAll('.vd-btn').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            selectedOptions[idx] = value;
            updatePrice(); updateImage(); updateAvailability();
          };
          valuesDiv.appendChild(btn);
        }
      });

      group.appendChild(valuesDiv);
      container.appendChild(group);
    });
  }

  function closePopup() {
    document.getElementById('vd-overlay').classList.remove('open');
    document.body.style.overflow = '';
  }

  document.getElementById('vd-close').onclick = closePopup;
  document.getElementById('vd-overlay').onclick = function (e) {
    if (e.target === this) closePopup();
  };

  document.getElementById('vd-minus').onclick = () => {
    currentQty = Math.max(1, currentQty - 1);
    document.getElementById('vd-qty').textContent = currentQty;
  };
  document.getElementById('vd-plus').onclick = () => {
    currentQty++;
    document.getElementById('vd-qty').textContent = currentQty;
  };

  // ============================================================
  // INJECTION FUNCTION - RECIPE + BUNDLE CARDS
  // ============================================================
  function injectViewDetailButtons() {
    // Target BOTH recipe cards and bundle cards
    document.querySelectorAll('.recipe-card.product-card, .product-card:not(.recipe-hidden)').forEach(card => {
      if (card.querySelector('.view-detail-btn')) return;

      const addBtn = card.querySelector('.add-btn');
      if (!addBtn) return;

      if (card.classList.contains('recipe-hidden')) return;

      const btn = document.createElement('button');
      btn.className = 'view-detail-btn';
      btn.innerHTML = '<span class="vd-info-icon">i</span> View Details';
      btn.type = 'button';

      btn.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const scriptEl = card.querySelector('script[type="application/json"]');
        if (!scriptEl) { 
          console.error('❌ No JSON script found in card');
          alert('Error loading product'); 
          return; 
        }

        let productData;
        try { 
          productData = JSON.parse(scriptEl.textContent); 
        }
        catch (err) { 
          console.error('❌ JSON Parse Error:', err);
          alert('Error parsing product data'); 
          return; 
        }

        openPopup(productData, addBtn, card);
      };

      const h4 = card.querySelector('h3, h4, .recipe-card__title, .card-title');
      if (h4) {
        h4.insertAdjacentElement('afterend', btn);
      } else {
        const container = card.querySelector('.recipe-card__body') || card.querySelector('.card-content');
        if (container) {
          container.prepend(btn);
        }
      }
    });
  }

  // ============================================================
  // OBSERVERS + INITIALIZATION
  // ============================================================
  const observer = new MutationObserver(() => {
    setTimeout(() => injectViewDetailButtons(), 100);
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      injectViewDetailButtons();
    });
  } else {
    injectViewDetailButtons();
  }

  setTimeout(injectViewDetailButtons, 300);
  setTimeout(injectViewDetailButtons, 800);
  setTimeout(injectViewDetailButtons, 1500);

})();
